<!--<template>-->
<!--  <div id="slider_layout">-->
<!--    <div :id="id" class="slider-content" >-->
<!--      <Loader v-if="load" />-->
<!--      <Error v-if="failed" />-->
<!--      <div :class="[myData.length === 0 ? 'd-flex align-items-center justify-center h-100' : 'h-100']">-->
<!--        <div v-if="myData.length === 0 && !load && !failed" class="empty-img-container">-->
<!--          <img :src="emptyImg"/>-->
<!--        </div>-->
<!--        <VueSlickCarousel-->
<!--          @afterChange="changePage"-->
<!--          v-bind="userRes2.includes(this.data.main.sectionId) ? wideCardSetting : userRes3.includes(this.data.main.sectionId) ? wideCardSetting : type === 'contactus' ? contactUsResponsive : settings"-->
<!--          :rtl="this.$lang === 'ar' ? true : false"-->
<!--          ref="slider1"-->
<!--          :key="key"-->
<!--          v-if="!load && !failed"-->
<!--        >-->
<!--          <div class="" v-for="(card,i) in myData" :key="i"-->
<!--          >-->
<!--            <div v-if="!useWideCard.includes(type) && type !== 'offer' && type !== 'contactus' && type !== 'press_releases_slider'">-->
<!--              <outer-card :sliderHolder="sliderHolder" :data="card" :cardType="type" />-->
<!--            </div>-->
<!--            <div v-if="useWideCard.includes(type)">-->
<!--              <wide-card :sliderHolder="sliderHolder" :data="card" :cardType="type" />-->
<!--            </div>-->
<!--            <div v-if="type === 'offer'" class="d-flex">-->
<!--              <div class="w-100">-->
<!--                <offer-card :data="card"/>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div v-if="type === 'contactus'" class="d-flex">-->
<!--              <div class="w-100 d-flex justify-content-center align-items-center">-->
<!--                <contactus-card :data="card"/>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div v-if="type === 'press_releases_slider'" class="">-->
<!--              <press-releasess-card :data="card" :cardType="pressType"/>-->
<!--            </div>-->
<!--          </div>-->
<!--        </VueSlickCarousel>-->
<!--      </div>-->
<!--      <div  v-if="totalElements > pageSize" :class="[this.$lang === 'ar' ? 'right-dir right-current' : 'left-current','current-all']">-->
<!--        <span>-->
<!--         <span v-if="currentSlide.toString().length === 1">0</span>{{ currentSlide }}-->
<!--          <span class="all"> / <span v-if="totalElements.toString().length === 1">0</span>{{ totalElements }} </span>-->
<!--        </span>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
<!--</template>-->
<!--&lt;!&ndash;v-if="show && info.length > showPerPage"&ndash;&gt;-->
<!--<script>-->
<!--import OuterCard from '../cards/OuterCard'-->
<!--import empty from '../../assets/images/empty-data.png'-->
<!--import VueSlickCarousel from 'vue-slick-carousel-rtl/dist/vue-slick-carousel-rtl.umd.js'-->
<!--import 'vue-slick-carousel-rtl/dist/vue-slick-carousel-rtl.css'-->
<!--import 'vue-slick-carousel-rtl/dist/vue-slick-carousel-theme.css'-->
<!--import WideCard from '../cards/WideCard'-->
<!--import $ from 'jquery'-->
<!--import OfferCard from '../cards/OfferCard'-->
<!--import ContactusCard from '../cards/ContactusCard'-->
<!--import PressReleasessCard from '../cards/PressReleasessCard'-->
<!--import Loader from '../LoaderBtn/Loader'-->
<!--import Error from '../errorHandle/Error'-->
<!--import gc from '../../utils/gc'-->
<!--export default {-->
<!--  name: 'SliderLayout',-->
<!--  props: {-->
<!--    data: {-->
<!--      type: Object-->
<!--    },-->
<!--    id: String,-->
<!--    pressType: String,-->
<!--    method: String,-->
<!--    obj: Object,-->
<!--    sliderHolder: String,-->
<!--    extraUrl: String-->
<!--  },-->
<!--  components: { Error, PressReleasessCard, ContactusCard, OfferCard, VueSlickCarousel, OuterCard, WideCard, Loader },-->
<!--  data () {-->
<!--    return {-->
<!--      emptyImg: empty,-->
<!--      key: 0,-->
<!--      info: [],-->
<!--      type: 1,-->
<!--      current: 1,-->
<!--      active1: 0,-->
<!--      active2: '',-->
<!--      visited: [0],-->
<!--      currentSlide: 1,-->
<!--      perPage: 1,-->
<!--      oldSlide: -100,-->
<!--      userRes2: ['social_responsibility', 'press_releases'],-->
<!--      userRes3: ['investor_relations'],-->
<!--      useWideCard: ['social-responsibility', 'press-releases', 'investor-relations'],-->
<!--      settings: {-->
<!--        dots: false,-->
<!--        arrows: false,-->
<!--        infinite: true,-->
<!--        speed: 300,-->
<!--        slidesToShow: 4,-->
<!--        initialSlide: 2,-->
<!--        centerMode: true,-->
<!--        centerPadding: '125',-->
<!--        slidesToScroll: 1,-->
<!--        touchThreshold: 5,-->
<!--        responsive: [-->
<!--          {-->
<!--            breakpoint: 1800,-->
<!--            settings: {-->
<!--              slidesToShow: 4,-->
<!--              slidesToScroll: 1,-->
<!--              initialSlide: 2,-->
<!--              centerPadding: '60'-->
<!--            }-->
<!--          },-->
<!--          {-->
<!--            breakpoint: 1590,-->
<!--            settings: {-->
<!--              slidesToShow: 3,-->
<!--              slidesToScroll: 1,-->
<!--              initialSlide: 1,-->
<!--              centerPadding: '145'-->
<!--            }-->
<!--          },-->
<!--          {-->
<!--            breakpoint: 1400,-->
<!--            settings: {-->
<!--              slidesToShow: 3,-->
<!--              slidesToScroll: 1,-->
<!--              infinite: true,-->
<!--              dots: false,-->
<!--              centerPadding: '100',-->
<!--              initialSlide: 1-->
<!--            }-->
<!--          },-->
<!--          {-->
<!--            breakpoint: 1300,-->
<!--            settings: {-->
<!--              slidesToShow: 3,-->
<!--              slidesToScroll: 1,-->
<!--              infinite: true,-->
<!--              dots: false,-->
<!--              centerPadding: '30',-->
<!--              initialSlide: 1-->
<!--            }-->
<!--          },-->
<!--          {-->
<!--            breakpoint: 1200,-->
<!--            settings: {-->
<!--              slidesToShow: 2,-->
<!--              slidesToScroll: 1,-->
<!--              infinite: true,-->
<!--              dots: false,-->
<!--              centerPadding: '150',-->
<!--              initialSlide: 1-->
<!--            }-->
<!--          },-->
<!--          {-->
<!--            breakpoint: 1070,-->
<!--            settings: {-->
<!--              slidesToShow: 2,-->
<!--              slidesToScroll: 1,-->
<!--              initialSlide: 1,-->
<!--              centerPadding: '90'-->
<!--            }-->
<!--          },-->
<!--          {-->
<!--            breakpoint: 890,-->
<!--            settings: {-->
<!--              slidesToShow: 2,-->
<!--              slidesToScroll: 1,-->
<!--              centerPadding: '0',-->
<!--              initialSlide: 1-->
<!--            }-->
<!--          },-->
<!--          {-->
<!--            breakpoint: 720,-->
<!--            settings: {-->
<!--              slidesToShow: 1,-->
<!--              slidesToScroll: 1,-->
<!--              centerPadding: '150',-->
<!--              initialSlide: 1-->
<!--            }-->
<!--          },-->
<!--          {-->
<!--            breakpoint: 680,-->
<!--            settings: {-->
<!--              slidesToShow: 1,-->
<!--              slidesToScroll: 1,-->
<!--              centerPadding: '140',-->
<!--              initialSlide: 0-->
<!--            }-->
<!--          },-->
<!--          {-->
<!--            breakpoint: 660,-->
<!--            settings: {-->
<!--              slidesToShow: 1,-->
<!--              slidesToScroll: 1,-->
<!--              centerPadding: '120',-->
<!--              initialSlide: 0-->
<!--            }-->
<!--          },-->
<!--          {-->
<!--            breakpoint: 570,-->
<!--            settings: {-->
<!--              slidesToShow: 1,-->
<!--              slidesToScroll: 1,-->
<!--              centerPadding: '100',-->
<!--              initialSlide: 0-->
<!--            }-->
<!--          },-->
<!--          {-->
<!--            breakpoint: 540,-->
<!--            settings: {-->
<!--              slidesToShow: 1,-->
<!--              slidesToScroll: 1,-->
<!--              centerPadding: '80',-->
<!--              initialSlide: 0-->
<!--            }-->
<!--          },-->
<!--          {-->
<!--            breakpoint: 480,-->
<!--            settings: {-->
<!--              slidesToShow: 1,-->
<!--              slidesToScroll: 1,-->
<!--              centerPadding: '0',-->
<!--              initialSlide: 0-->
<!--            }-->
<!--          },-->
<!--          {-->
<!--            breakpoint: 320,-->
<!--            settings: {-->
<!--              slidesToShow: 1,-->
<!--              slidesToScroll: 1,-->
<!--              centerPadding: '0',-->
<!--              initialSlide: 0-->
<!--            }-->
<!--          }-->
<!--        ]-->
<!--      },-->
<!--      wideCardSetting: {-->
<!--        dots: false,-->
<!--        arrows: false,-->
<!--        infinite: true,-->
<!--        speed: 300,-->
<!--        slidesToShow: 3,-->
<!--        initialSlide: 1,-->
<!--        centerMode: true,-->
<!--        centerPadding: '80',-->
<!--        slidesToScroll: 3,-->
<!--        touchThreshold: 5,-->
<!--        responsive: [-->
<!--          {-->
<!--            breakpoint: 2000,-->
<!--            settings: {-->
<!--              slidesToShow: 3,-->
<!--              slidesToScroll: 1,-->
<!--              infinite: true,-->
<!--              dots: false,-->
<!--              centerPadding: '160',-->
<!--              initialSlide: 1-->
<!--            }-->
<!--          },-->
<!--          {-->
<!--            breakpoint: 1650,-->
<!--            settings: {-->
<!--              slidesToShow: 3,-->
<!--              slidesToScroll: 1,-->
<!--              infinite: true,-->
<!--              dots: false,-->
<!--              centerPadding: '110',-->
<!--              initialSlide: 1-->
<!--            }-->
<!--          },-->
<!--          {-->
<!--            breakpoint: 1500,-->
<!--            settings: {-->
<!--              slidesToShow: 3,-->
<!--              slidesToScroll: 1,-->
<!--              infinite: true,-->
<!--              dots: false,-->
<!--              centerPadding: '50',-->
<!--              initialSlide: 1-->
<!--            }-->
<!--          },-->
<!--          {-->
<!--            breakpoint: 1450,-->
<!--            settings: {-->
<!--              slidesToShow: 3,-->
<!--              slidesToScroll: 1,-->
<!--              infinite: true,-->
<!--              dots: false,-->
<!--              centerPadding: '35',-->
<!--              initialSlide: 1-->
<!--            }-->
<!--          },-->
<!--          {-->
<!--            breakpoint: 1400,-->
<!--            settings: {-->
<!--              slidesToShow: 3,-->
<!--              slidesToScroll: 1,-->
<!--              infinite: true,-->
<!--              dots: false,-->
<!--              centerPadding: '25',-->
<!--              initialSlide: 1-->
<!--            }-->
<!--          },-->
<!--          {-->
<!--            breakpoint: 1350,-->
<!--            settings: {-->
<!--              slidesToShow: 2,-->
<!--              slidesToScroll: 1,-->
<!--              infinite: true,-->
<!--              dots: false,-->
<!--              centerPadding: '175',-->
<!--              initialSlide: 1-->
<!--            }-->
<!--          },-->
<!--          {-->
<!--            breakpoint: 1300,-->
<!--            settings: {-->
<!--              slidesToShow: 2,-->
<!--              slidesToScroll: 1,-->
<!--              infinite: true,-->
<!--              dots: false,-->
<!--              centerPadding: '150',-->
<!--              initialSlide: 1-->
<!--            }-->
<!--          },-->
<!--          {-->
<!--            breakpoint: 1200,-->
<!--            settings: {-->
<!--              slidesToShow: 2,-->
<!--              slidesToScroll: 1,-->
<!--              initialSlide: 1,-->
<!--              centerPadding: '130'-->
<!--            }-->
<!--          },-->
<!--          {-->
<!--            breakpoint: 1120,-->
<!--            settings: {-->
<!--              slidesToShow: 2,-->
<!--              slidesToScroll: 1,-->
<!--              initialSlide: 1,-->
<!--              centerPadding: '100'-->
<!--            }-->
<!--          },-->
<!--          {-->
<!--            breakpoint: 1050,-->
<!--            settings: {-->
<!--              slidesToShow: 2,-->
<!--              slidesToScroll: 1,-->
<!--              infinite: true,-->
<!--              dots: false,-->
<!--              centerPadding: '80',-->
<!--              initialSlide: 1-->
<!--            }-->
<!--          },-->
<!--          {-->
<!--            breakpoint: 1000,-->
<!--            settings: {-->
<!--              slidesToShow: 2,-->
<!--              slidesToScroll: 1,-->
<!--              infinite: true,-->
<!--              dots: false,-->
<!--              centerPadding: '30',-->
<!--              initialSlide: 1-->
<!--            }-->
<!--          },-->
<!--          {-->
<!--            breakpoint: 930,-->
<!--            settings: {-->
<!--              slidesToShow: 2,-->
<!--              slidesToScroll: 1,-->
<!--              infinite: true,-->
<!--              dots: false,-->
<!--              centerPadding: '0',-->
<!--              initialSlide: 1-->
<!--            }-->
<!--          },-->
<!--          {-->
<!--            breakpoint: 880,-->
<!--            settings: {-->
<!--              slidesToShow: 1,-->
<!--              slidesToScroll: 1,-->
<!--              centerPadding: '175',-->
<!--              initialSlide: 0-->
<!--            }-->
<!--          },-->
<!--          {-->
<!--            breakpoint: 780,-->
<!--            settings: {-->
<!--              slidesToShow: 1,-->
<!--              slidesToScroll: 1,-->
<!--              infinite: true,-->
<!--              dots: false,-->
<!--              centerPadding: '150',-->
<!--              initialSlide: 1-->
<!--            }-->
<!--          },-->
<!--          {-->
<!--            breakpoint: 730,-->
<!--            settings: {-->
<!--              slidesToShow: 1,-->
<!--              slidesToScroll: 1,-->
<!--              infinite: true,-->
<!--              dots: false,-->
<!--              centerPadding: '125',-->
<!--              initialSlide: 1-->
<!--            }-->
<!--          },-->
<!--          {-->
<!--            breakpoint: 670,-->
<!--            settings: {-->
<!--              slidesToShow: 1,-->
<!--              slidesToScroll: 1,-->
<!--              centerPadding: '100',-->
<!--              initialSlide: 0-->
<!--            }-->
<!--          },-->
<!--          {-->
<!--            breakpoint: 630,-->
<!--            settings: {-->
<!--              slidesToShow: 1,-->
<!--              slidesToScroll: 1,-->
<!--              centerPadding: '75',-->
<!--              initialSlide: 0-->
<!--            }-->
<!--          },-->
<!--          {-->
<!--            breakpoint: 580,-->
<!--            settings: {-->
<!--              slidesToShow: 1,-->
<!--              slidesToScroll: 1,-->
<!--              centerPadding: '55',-->
<!--              initialSlide: 0-->
<!--            }-->
<!--          },-->
<!--          {-->
<!--            breakpoint: 480,-->
<!--            settings: {-->
<!--              slidesToShow: 1,-->
<!--              slidesToScroll: 1,-->
<!--              centerPadding: '0',-->
<!--              initialSlide: 0-->
<!--            }-->
<!--          }-->
<!--        ]-->
<!--      },-->
<!--      contactUsResponsive: {-->
<!--        dots: false,-->
<!--        arrows: false,-->
<!--        infinite: true,-->
<!--        speed: 300,-->
<!--        slidesToShow: 5,-->
<!--        initialSlide: 1,-->
<!--        centerMode: true,-->
<!--        centerPadding: '80',-->
<!--        slidesToScroll: 3,-->
<!--        touchThreshold: 5,-->
<!--        responsive: [-->
<!--          {-->
<!--            breakpoint: 1600,-->
<!--            settings: {-->
<!--              slidesToShow: 4,-->
<!--              slidesToScroll: 1,-->
<!--              infinite: true,-->
<!--              dots: false,-->
<!--              centerPadding: '110',-->
<!--              initialSlide: 1-->
<!--            }-->
<!--          },-->
<!--          {-->
<!--            breakpoint: 1500,-->
<!--            settings: {-->
<!--              slidesToShow: 4,-->
<!--              slidesToScroll: 1,-->
<!--              infinite: true,-->
<!--              dots: false,-->
<!--              centerPadding: '110',-->
<!--              initialSlide: 1-->
<!--            }-->
<!--          },-->
<!--          {-->
<!--            breakpoint: 1400,-->
<!--            settings: {-->
<!--              slidesToShow: 4,-->
<!--              slidesToScroll: 1,-->
<!--              infinite: true,-->
<!--              dots: false,-->
<!--              centerPadding: '70',-->
<!--              initialSlide: 1-->
<!--            }-->
<!--          },-->
<!--          {-->
<!--            breakpoint: 1300,-->
<!--            settings: {-->
<!--              slidesToShow: 4,-->
<!--              slidesToScroll: 1,-->
<!--              infinite: true,-->
<!--              dots: false,-->
<!--              centerPadding: '60',-->
<!--              initialSlide: 1-->
<!--            }-->
<!--          },-->
<!--          {-->
<!--            breakpoint: 1250,-->
<!--            settings: {-->
<!--              slidesToShow: 4,-->
<!--              slidesToScroll: 1,-->
<!--              infinite: true,-->
<!--              dots: false,-->
<!--              centerPadding: '40',-->
<!--              initialSlide: 1-->
<!--            }-->
<!--          },-->
<!--          {-->
<!--            breakpoint: 1200,-->
<!--            settings: {-->
<!--              slidesToShow: 4,-->
<!--              slidesToScroll: 1,-->
<!--              initialSlide: 1,-->
<!--              centerPadding: '40 '-->
<!--            }-->
<!--          },-->
<!--          {-->
<!--            breakpoint: 1170,-->
<!--            settings: {-->
<!--              slidesToShow: 4,-->
<!--              slidesToScroll: 1,-->
<!--              initialSlide: 1,-->
<!--              centerPadding: '20 '-->
<!--            }-->
<!--          },-->
<!--          {-->
<!--            breakpoint: 1115,-->
<!--            settings: {-->
<!--              slidesToShow: 3,-->
<!--              slidesToScroll: 1,-->
<!--              initialSlide: 1,-->
<!--              centerPadding: '110'-->
<!--            }-->
<!--          },-->
<!--          {-->
<!--            breakpoint: 1020,-->
<!--            settings: {-->
<!--              slidesToShow: 3,-->
<!--              slidesToScroll: 1,-->
<!--              initialSlide: 1,-->
<!--              centerPadding: '60'-->
<!--            }-->
<!--          },-->
<!--          {-->
<!--            breakpoint: 950,-->
<!--            settings: {-->
<!--              slidesToShow: 3,-->
<!--              slidesToScroll: 1,-->
<!--              initialSlide: 0,-->
<!--              centerPadding: '40'-->
<!--            }-->
<!--          },-->
<!--          {-->
<!--            breakpoint: 915,-->
<!--            settings: {-->
<!--              slidesToShow: 3,-->
<!--              slidesToScroll: 1,-->
<!--              initialSlide: 0,-->
<!--              centerPadding: '20'-->
<!--            }-->
<!--          },-->
<!--          {-->
<!--            breakpoint: 880,-->
<!--            settings: {-->
<!--              slidesToShow: 3,-->
<!--              slidesToScroll: 1,-->
<!--              initialSlide: 0,-->
<!--              centerPadding: '10'-->
<!--            }-->
<!--          },-->
<!--          {-->
<!--            breakpoint: 850,-->
<!--            settings: {-->
<!--              slidesToShow: 3,-->
<!--              slidesToScroll: 1,-->
<!--              centerPadding: '20',-->
<!--              initialSlide: 0-->
<!--            }-->
<!--          },-->
<!--          {-->
<!--            breakpoint: 840,-->
<!--            settings: {-->
<!--              slidesToShow: 3,-->
<!--              slidesToScroll: 1,-->
<!--              centerPadding: '10',-->
<!--              initialSlide: 0-->
<!--            }-->
<!--          },-->
<!--          {-->
<!--            breakpoint: 820,-->
<!--            settings: {-->
<!--              slidesToShow: 2,-->
<!--              slidesToScroll: 1,-->
<!--              centerPadding: '100',-->
<!--              initialSlide: 0-->
<!--            }-->
<!--          },-->
<!--          {-->
<!--            breakpoint: 755,-->
<!--            settings: {-->
<!--              slidesToShow: 2,-->
<!--              slidesToScroll: 1,-->
<!--              centerPadding: '75',-->
<!--              initialSlide: 0-->
<!--            }-->
<!--          },-->
<!--          {-->
<!--            breakpoint: 700,-->
<!--            settings: {-->
<!--              slidesToShow: 2,-->
<!--              slidesToScroll: 1,-->
<!--              centerPadding: '40',-->
<!--              initialSlide: 0-->
<!--            }-->
<!--          },-->
<!--          {-->
<!--            breakpoint: 655,-->
<!--            settings: {-->
<!--              slidesToShow: 2,-->
<!--              slidesToScroll: 1,-->
<!--              centerPadding: '45',-->
<!--              initialSlide: 0-->
<!--            }-->
<!--          },-->
<!--          {-->
<!--            breakpoint: 630,-->
<!--            settings: {-->
<!--              slidesToShow: 2,-->
<!--              slidesToScroll: 1,-->
<!--              centerPadding: '20',-->
<!--              initialSlide: 0-->
<!--            }-->
<!--          },-->
<!--          {-->
<!--            breakpoint: 600,-->
<!--            settings: {-->
<!--              slidesToShow: 2,-->
<!--              slidesToScroll: 1,-->
<!--              centerPadding: '5',-->
<!--              initialSlide: 0-->
<!--            }-->
<!--          },-->

<!--          {-->
<!--            breakpoint: 550,-->
<!--            settings: {-->
<!--              slidesToShow: 1,-->
<!--              slidesToScroll: 1,-->
<!--              centerPadding: '0',-->
<!--              initialSlide: 0-->
<!--            }-->
<!--          }-->
<!--        ]-->
<!--      },-->
<!--      direction: false,-->
<!--      flipNum: 0,-->
<!--      centerModeProp: false,-->
<!--      showPerPage: 0,-->
<!--      display: this.show,-->
<!--      /* &#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45; new logic -&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45; */-->
<!--      myData: [],-->
<!--      load: false,-->
<!--      failed: false,-->
<!--      size: 5,-->
<!--      shouldBeDragged: 0,-->
<!--      totalElements: 0,-->
<!--      pageSize: 0,-->
<!--      latestPagesNum: 0,-->
<!--      fetchedPages: []-->
<!--    }-->
<!--  },-->
<!--  watch: {-->
<!--  },-->
<!--  created () {-->
<!--    this.info = this.data.slider-->
<!--    this.type = this.data.main.cardType-->
<!--    if (this.data.sliderType === 'cardsMiniSlider') { // this data will be received in case of mobile screen which will convert the random cards section to a slider-->
<!--      this.getMiniSliderData() // if the previous condition return true this function will be called-->
<!--    } else { // or in normal case this is the function that will called-->
<!--      this.getData(0)-->
<!--    }-->
<!--  },-->
<!--  mounted () {-->
<!--    this.$lang === 'ar' ? this.direction = true : this.direction = false-->
<!--    setTimeout(() => {-->
<!--      this.styling()-->
<!--    })-->
<!--    this.$watch(() => {-->
<!--      return this.$store.state.window-->
<!--    }, (val) => {-->
<!--      this.styling()-->
<!--    })-->
<!--  },-->
<!--  methods: {-->
<!--    async getMiniSliderData () {-->
<!--      this.load = true-->
<!--      try {-->
<!--        const response = await this.obj[this.method]()-->
<!--        if (response.status === 200) {-->
<!--          for (let i = 0; i < response.data.length; i++) {-->
<!--            let temp-->
<!--            if (this.sliderHolder === 'pressReleases') { // if this slider in press releases section this is the passed object-->
<!--              temp = { id: response.data[i].id, title: response.data[i].title, description: response.data[i].html, icon: gc.baseUrl + '/customerCare' + response.data[i].newsMedia[0].media, styles: i === 0 ? 'col-lg-8 col-12 main' : i === 1 ? 'col-lg-12 col-6 second' : 'col-lg-12 col-6 third' }-->
<!--            } else if (this.sliderHolder === 'randomOffers') { // if the slider in random offers section in home page this object will be passed-->
<!--              temp = { type: 'random-offers', title: response.data[i].title, description: response.data[i].description, link: response.data[i].link, icon: gc.baseUrl + '/customerCare' + response.data[i].largeImage, smallIcon: gc.baseUrl + '/customerCare' + response.data[i].smallImage, styles: i === 0 ? 'col-lg-8 col-12 main' : i === 1 ? 'col-lg-12 col-6 second' : i === 2 ? 'col-lg-12 col-6 third' : '' }-->
<!--            } else if (this.sliderHolder === 'socialResponsibility') { // if the slider in social responibility-->
<!--              temp = {-->
<!--                id: response.data[i].id,-->
<!--                title: response.data[i].title,-->
<!--                description: response.data[i].text,-->
<!--                icon: gc.baseUrl + '/customerCare' + response.data[i].socialResponsibilityMedia[0].media,-->
<!--                styles: i === 0 ? 'col-lg-8 col-12 main' : i === 1 ? 'col-lg-12 col-6 second' : 'col-lg-12 col-6 third'-->
<!--              }-->
<!--            } else if (this.sliderHolder === 'contactUs') {-->
<!--              temp = response.data[i]-->
<!--            }-->
<!--            this.myData.push(temp)-->
<!--          }-->
<!--          this.totalElements = response.data.length-->
<!--        } else {-->
<!--          this.failed = true-->
<!--        }-->
<!--      } catch (e) {-->
<!--        this.failed = true-->
<!--      }-->
<!--      this.load = false-->
<!--    },-->
<!--    styling () {-->
<!--      this.$lang === 'ar' ? $('.current-all').css('right', '4vw') : $('.current-all').css('left', '4vw')-->
<!--      $('#investor_relations .current-all').css('bottom', '-12px')-->
<!--      $('#investor_relations .swipe').css('bottom', '-5px')-->
<!--      $('#social_responsibility .current-all').css('bottom', '2px')-->
<!--      $('#social_responsibility .current-all').css('padding-bottom', '2px')-->
<!--      this.$lang === 'ar' ? $('img.arrows').css('transform', 'rotateY(180deg)') : $('img.arrows').css('transform', 'rotateY(0deg)')-->
<!--      this.$lang === 'ar' ? $('#slider_layout img.outer_image').css('transform', 'rotateY(180deg)') : $('#slider_layout img.outer_image').css('transform', 'rotateY(0deg)')-->
<!--      this.$lang === 'ar' ? $('#slider_layout #inner_card').css('right', '48.5px') : $('#slider_layout #inner_card').css('right', '64.5px')-->
<!--      if (this.type === 'contactus') {-->
<!--        $(`#${this.data.main.sectionId} .slider-container`).css('height', '100%')-->
<!--        $(`#${this.data.main.sectionId} #slider_layout`).css('margin-top', '2rem')-->
<!--        $(`#${this.data.main.sectionId} #slider_layout`).css('height', '420px')-->
<!--      }-->
<!--    },-->
<!--    changePage (num) {-->
<!--      if (this.totalElements <= this.$refs.slider1.settings.slidesToShow) {-->
<!--        return // dont do anything if the totalElements less than how many slider must be shown in the screen-->
<!--      }-->
<!--      if (this.$refs.slider1.$children[0].currentDirection === 0 && num !== this.oldSlide) { // check the direction of the dragging is forward-->
<!--        if (this.currentSlide + 1 <= this.totalElements) { // if the current slide added by one is less than the totalElements length-->
<!--          this.currentSlide += 1 // if the condition true then increase it by one-->
<!--        } else {-->
<!--          this.currentSlide = 1 // else return to one-->
<!--        }-->
<!--        this.changeForward(this.currentSlide)-->
<!--      }-->
<!--      if (this.$refs.slider1.$children[0].currentDirection === 1 && num !== this.oldSlide) { // check the direction of the dragging is backward-->
<!--        if (this.currentSlide - 1 <= 0) { // if we the current slide decreased by one less than or equal to zero-->
<!--          this.currentSlide = this.totalElements // make the current slide is the last element of the array-->
<!--        } else {-->
<!--          this.currentSlide -= 1 // else decrease it by one-->
<!--        }-->
<!--        this.changeBackward(this.currentSlide)-->
<!--      }-->
<!--      this.oldSlide = num-->
<!--    },-->
<!--    async getData (page) {-->
<!--      this.load = true // start the loader-->
<!--      const size = this.size // page size-->
<!--      const obj = this.obj // the instance object of the repositories folder classes-->
<!--      const method = this.method // the method name-->
<!--      const id = this.data.id // the id of the url (passed with the data object from the main section)-->
<!--      const type = this.data.durationType // if the type daily, weakly or monthly (passed with the data object from the main section)-->
<!--      const line = this.data.lineType // if the line type prepaid or post paid (passed with the data object from the main section)-->
<!--      try {-->
<!--        let response-->
<!--        if (this.data.sliderType === 'press&social') { // passed from the main section to specify the passed parameters-->
<!--          response = await obj[method](this.extraUrl, page, size)-->
<!--        } else if (this.data.sliderType === 'bundle' || this.data.sliderType === 'segment') {-->
<!--          response = await obj[method](id, page, size, type, line)-->
<!--        } else if (this.data.sliderType === 'offer') {-->
<!--          response = await obj[method](id, page, size, line)-->
<!--        } else {-->
<!--          response = await obj[method](page, size)-->
<!--        }-->
<!--        if (response.status === 200) {-->
<!--          this.fetchedPages.push(page) // if the page fetched successfully we push its number to this array to prevent reorder it-->
<!--          const temp = this.data.sliderType === 'bundle' || this.data.sliderType === 'segment' ? response.content : this.data.sliderType === 'offer' ? response.data.data.data : response.data.data-->
<!--          await this.firstPushRendering(temp)-->
<!--          this.totalElements = this.data.sliderType === 'bundle' || this.data.sliderType === 'segment' ? response.count : this.data.sliderType === 'offer' ? response.data.data.totalElements : response.data.totalElements-->
<!--          this.shouldBeDragged = Math.ceil(this.totalElements / size) // how many times we should request pages to get the total data-->
<!--          if (this.shouldBeDragged > 1) {-->
<!--            await this.emptyInitial(this.size, this.totalElements)-->
<!--          }-->
<!--        } else {-->
<!--          this.failed = true-->
<!--        }-->
<!--      } catch (e) {-->
<!--        console.log(e)-->
<!--        this.failed = true-->
<!--      }-->
<!--      if (this.shouldBeDragged === 2) {-->
<!--        await this.getEdgeData(1)-->
<!--      } else if (this.shouldBeDragged > 2) {-->
<!--        await this.getEdgeData(1)-->
<!--        await this.getEdgeData(this.shouldBeDragged - 1)-->
<!--      }-->
<!--      this.load = false-->
<!--      setTimeout(() => {-->
<!--        this.pageSize = Math.ceil(this.$refs.slider1.settings.slidesToShow)-->
<!--        this.$emit('total-elements', { total: this.totalElements, pageSize: Math.ceil(this.$refs.slider1.settings.slidesToShow) })-->
<!--      })-->
<!--    },-->
<!--    async getEdgeData (page) {-->
<!--      const size = this.size-->
<!--      const obj = this.obj-->
<!--      const method = this.method-->
<!--      const id = this.data.id-->
<!--      const type = this.data.durationType-->
<!--      const line = this.data.lineType-->
<!--      try {-->
<!--        let response-->
<!--        if (this.data.sliderType === 'press&social') {-->
<!--          response = await obj[method](this.extraUrl, page, size)-->
<!--        } else if (this.data.sliderType === 'bundle' || this.data.sliderType === 'segment') {-->
<!--          response = await obj[method](id, page, size, type, line)-->
<!--        } else if (this.data.sliderType === 'offer') {-->
<!--          response = await obj[method](id, page, size, line)-->
<!--        } else {-->
<!--          response = await obj[method](page, size)-->
<!--        }-->
<!--        if (response.status === 200) {-->
<!--          this.fetchedPages.push(page)-->
<!--          const temp = this.data.sliderType === 'bundle' || this.data.sliderType === 'segment' ? response.content : this.data.sliderType === 'offer' ? response.data.data.data : response.data.data-->
<!--          if (page === 1) {-->
<!--            this.rendering(temp, page, (page + 1) * this.size)-->
<!--          } else {-->
<!--            this.rendering(temp, page, this.totalElements)-->
<!--          }-->
<!--        } else {-->
<!--          this.failed = true-->
<!--        }-->
<!--      } catch (e) {-->
<!--        // the next row returns an error-->
<!--        // this.failed = true-->
<!--      }-->
<!--    },-->
<!--    async changeForward (val) {-->
<!--      const page = Math.floor((val - 1) / this.size) + 2// the val is the number of the current slide that the page is the number of the page of this slide-->
<!--      const size = this.size-->
<!--      const obj = this.obj-->
<!--      const method = this.method-->
<!--      const id = this.data.id-->
<!--      const type = this.data.durationType-->
<!--      const line = this.data.lineType-->
<!--      if (!this.fetchedPages.includes(page) && page < this.shouldBeDragged - 1 && val % this.size === 0) { // check if this page fetched before and the page number is less than how many elements should be dragged and the last condition is to prevent the user from asking the page in each swipe and ask for the page after in the edge of the page-->
<!--        try {-->
<!--          let response-->
<!--          if (this.data.sliderType === 'press&social') {-->
<!--            response = await obj[method](this.extraUrl, page, size)-->
<!--          } else if (this.data.sliderType === 'bundle' || this.data.sliderType === 'segment') {-->
<!--            response = await obj[method](id, page, size, type, line)-->
<!--          } else if (this.data.sliderType === 'offer') {-->
<!--            response = await obj[method](id, page, size, line)-->
<!--          } else {-->
<!--            response = await obj[method](page, size)-->
<!--          }-->
<!--          if (response.status === 200) {-->
<!--            const temp = this.data.sliderType === 'bundle' || this.data.sliderType === 'segment' ? response.content : this.data.sliderType === 'offer' ? response.data.data.data : response.data.data-->
<!--            this.rendering(temp, page, (page + 1) * this.size)-->
<!--            this.fetchedPages.push(page)-->
<!--            setTimeout(() => {-->
<!--              this.$refs.slider1.$forceUpdate()-->
<!--              this.$store.state.sliderUpdated++-->
<!--            })-->
<!--          }-->
<!--        } catch (e) {-->
<!--          return e-->
<!--        }-->
<!--      } else if (!this.visited.includes(page) && page === this.shouldBeDragged - 1 && val % this.size === 0) {-->
<!--        try {-->
<!--          let response-->
<!--          if (this.data.sliderType === 'press&social') {-->
<!--            response = await obj[method](this.extraUrl, page, size)-->
<!--          } else if (this.data.sliderType === 'bundle' || this.data.sliderType === 'segment') {-->
<!--            response = await obj[method](id, page, size, type, line)-->
<!--          } else if (this.data.sliderType === 'offer') {-->
<!--            response = await obj[method](id, page, size, line)-->
<!--          } else {-->
<!--            response = await obj[method](page, size)-->
<!--          }-->
<!--          if (response.status === 200) {-->
<!--            const temp = this.data.sliderType === 'bundle' || this.data.sliderType === 'segment' ? response.content : this.data.sliderType === 'offer' ? response.data.data.data : response.data.data-->
<!--            this.rendering(temp, page, this.totalElements)-->
<!--            this.fetchedPages.push(page)-->
<!--            setTimeout(() => {-->
<!--              this.$refs.slider1.$forceUpdate()-->
<!--              this.$store.state.sliderUpdated++-->
<!--            })-->
<!--          }-->
<!--        } catch (e) {-->
<!--          return e-->
<!--        }-->
<!--      }-->
<!--    },-->
<!--    async changeBackward (val) {-->
<!--      const page = Math.floor((val - 1) / this.size) - 1-->
<!--      const size = this.size-->
<!--      const obj = this.obj-->
<!--      const method = this.method-->
<!--      const id = this.data.id-->
<!--      const type = this.data.durationType-->
<!--      const line = this.data.lineType-->
<!--      if (!this.fetchedPages.includes(page) && page < this.shouldBeDragged - 1 && page > 0 && (val % this.size === 0)) {-->
<!--        try {-->
<!--          let response-->
<!--          if (this.data.sliderType === 'press&social') {-->
<!--            response = await obj[method](this.extraUrl, page, size)-->
<!--          } else if (this.data.sliderType === 'bundle' || this.data.sliderType === 'segment') {-->
<!--            response = await obj[method](id, page, size, type, line)-->
<!--          } else if (this.data.sliderType === 'offer') {-->
<!--            response = await obj[method](id, page, size, line)-->
<!--          } else {-->
<!--            response = await obj[method](page, size)-->
<!--          }-->
<!--          if (response.status === 200) {-->
<!--            const temp = this.data.sliderType === 'bundle' || this.data.sliderType === 'segment' ? response.content : this.data.sliderType === 'offer' ? response.data.data.data : response.data.data-->
<!--            this.fetchedPages.push(page)-->
<!--            this.rendering(temp, page, (page + 1) * this.size)-->
<!--          }-->
<!--        } catch (e) {-->
<!--          return e-->
<!--        }-->
<!--      } else if (!this.fetchedPages.includes(page) && page === this.shouldBeDragged - 2 && page > 0) {-->
<!--        try {-->
<!--          let response-->
<!--          if (this.data.sliderType === 'press&social') {-->
<!--            response = await obj[method](this.extraUrl, page, size)-->
<!--          } else if (this.data.sliderType === 'bundle' || this.data.sliderType === 'segment') {-->
<!--            response = await obj[method](id, page, size, type, line)-->
<!--          } else if (this.data.sliderType === 'offer') {-->
<!--            response = await obj[method](id, page, size, line)-->
<!--          } else {-->
<!--            response = await obj[method](page, size)-->
<!--          }-->
<!--          if (response.status === 200) {-->
<!--            const temp = this.data.sliderType === 'bundle' || this.data.sliderType === 'segment' ? response.content : this.data.sliderType === 'offer' ? response.data.data.data : response.data.data-->
<!--            this.fetchedPages.push(page)-->
<!--            this.rendering(temp, page, this.totalElements)-->
<!--          }-->
<!--        } catch (e) {-->
<!--          return e-->
<!--        }-->
<!--      }-->
<!--    },-->
<!--    rendering (temp, page, elements) {-->
<!--      for (let i = page * this.size; i < elements; i++) {-->
<!--        if (this.sliderHolder === 'popularBundles') {-->
<!--          this.myData[i].id = temp[i - (page * this.size)].id-->
<!--          this.myData[i].title = temp[i - (page * this.size)].title-->
<!--          this.myData[i].description[0].value = `${temp[i - (page * this.size)].dataSize} ${temp[i - (page * this.size)].dataUnit}`-->
<!--          this.myData[i].description[0].desc = temp[i - (page * this.size)].dataNote-->
<!--          this.myData[i].description[1].value = `${temp[i - (page * this.size)].minuteCount}${this.$t('Bundles.min')}`-->
<!--          this.myData[i].description[1].desc = temp[i - (page * this.size)].minuteNote-->
<!--          this.myData[i].description[2].value = `${temp[i - (page * this.size)].smsCount}${this.$t('Bundles.sms')}`-->
<!--          this.myData[i].description[2].desc = temp[i - (page * this.size)].smsNote-->
<!--          this.myData[i].price = `${temp[i - (page * this.size)].price} ${this.$t('Bundles.sp')}`-->
<!--          this.myData[i].unit = `/ ${temp[i - (page * this.size)].type === 0 ? this.$t('Bundles.day') : temp[i - (page * this.size)].type === 1 ? this.$t('Bundles.week') : this.$t('Bundles.month')}`-->
<!--        } else if (this.sliderHolder === 'mtnApps') {-->
<!--          this.myData[i].id = temp[i - (page * this.size)].id-->
<!--          this.myData[i].title = temp[i - (page * this.size)].title-->
<!--          this.myData[i].description = temp[i - (page * this.size)].description-->
<!--          this.myData[i].icon = gc.baseUrl + '/customerCare' + temp[i - (page * this.size)].icon-->
<!--          this.myData[i].link = temp[i - (page * this.size)][0].link-->
<!--          this.myData[i].background = gc.baseUrl + '/customerCare' + temp[i - (page * this.size)].background-->
<!--        } else if (this.sliderHolder === 'specialServices') {-->
<!--          this.myData[i].id = temp[i - (page * this.size)].id-->
<!--          this.myData[i].title = temp[i - (page * this.size)].title-->
<!--          this.myData[i].description = temp[i - (page * this.size)].description-->
<!--          this.myData[i].link = temp[i - (page * this.size)].link-->
<!--        } else if (this.sliderHolder === 'bundle' || this.sliderHolder === 'segment') {-->
<!--          this.myData[i].id = temp[i - (page * this.size)].id-->
<!--          this.myData[i].title = temp[i - (page * this.size)].title-->
<!--          this.myData[i].description[0].value = `${temp[i - (page * this.size)].dataSize} ${temp[i - (page * this.size)].dataUnit}`-->
<!--          this.myData[i].description[0].desc = temp[i - (page * this.size)].dataNote-->
<!--          this.myData[i].description[1].value = `${temp[i - (page * this.size)].minuteCount}${this.$t('Bundles.min')}`-->
<!--          this.myData[i].description[1].desc = temp[i - (page * this.size)].minuteNote-->
<!--          this.myData[i].description[2].value = `${temp[i - (page * this.size)].smsCount}${this.$t('Bundles.sms')}`-->
<!--          this.myData[i].description[2].desc = temp[i - (page * this.size)].smsNote-->
<!--          this.myData[i].price = `${temp[i - (page * this.size)].price}${this.$t('Bundles.sp')}`-->
<!--        } else if (this.sliderHolder === 'offer') {-->
<!--          this.myData[i].id = temp[i - (page * this.size)].id-->
<!--          this.myData[i].title = temp[i - (page * this.size)].title-->
<!--          this.myData[i].description = temp[i - (page * this.size)].description-->
<!--          this.myData[i].price = temp[i - (page * this.size)].price-->
<!--          this.myData[i].price = `${temp[i - (page * this.size)].price} ${this.$t('Bundles.sp')}`-->
<!--          this.myData[i].link = temp[i - (page * this.size)].link-->
<!--        } else if (this.sliderHolder === 'investorRelations') {-->
<!--          this.myData[i].id = temp[i - (page * this.size)].id-->
<!--          this.myData[i].desc = temp[i - (page * this.size)].text-->
<!--          this.myData[i].date = temp[i - (page * this.size)].date-->
<!--          this.myData[i].img = gc.baseUrl + '/customerCare' + temp[i - (page * this.size)].image-->
<!--          this.myData[i].file = gc.baseUrl + '/customerCare' + temp[i - (page * this.size)].investorFiles[0].file-->
<!--          this.myData[i].fileId = temp[i - (page * this.size)].investorFiles[0].id-->
<!--        } else if (this.sliderHolder === 'pressReleases') {-->
<!--          this.myData[i].id = temp[i - (page * this.size)].id-->
<!--          this.myData[i].title = temp[i - (page * this.size)].title-->
<!--          this.myData[i].description = temp[i - (page * this.size)].description-->
<!--          this.myData[i].icon = gc.baseUrl + '/customerCare' + temp[i - (page * this.size)].icon-->
<!--          this.myData[i].slider[i].link = temp[i - (page * this.size)].link-->
<!--        } else if (this.sliderHolder === 'socialResponsibility') {-->
<!--          this.myData[i].id = temp[i - (page * this.size)].id-->
<!--          this.myData[i].img = gc.baseUrl + '/customerCare' + temp[i - (page * this.size)].socialResponsibilityMedia[0].media-->
<!--          this.myData[i].imgDesc = temp[i - (page * this.size)].title-->
<!--          this.myData[i].desc = temp[i - (page * this.size)].text-->
<!--          this.myData[i].time = temp[i - (page * this.size)].socialDate-->
<!--        }-->
<!--      }-->
<!--    },-->
<!--    firstPushRendering (temp) {-->
<!--      for (let i = 0; i < temp.length; i++) {-->
<!--        if (this.sliderHolder === 'popularBundles') {-->
<!--          this.myData.push({-->
<!--            id: temp[i].id,-->
<!--            title: temp[i].title,-->
<!--            description: [{ value: `${temp[i].dataSize} ${temp[i].dataUnit}`, desc: temp[i].dataNote }, { value: `${temp[i].minuteCount}${this.$t('Bundles.min')}`, desc: temp[i].minuteNote }, { value: `${temp[i].smsCount}${this.$t('Bundles.sms')}`, desc: temp[i].smsNote }],-->
<!--            icon: '',-->
<!--            price: `${temp[i].price} ${this.$t('Bundles.sp')} `,-->
<!--            unit: `/ ${temp[i].type === 0 ? this.$t('Bundles.day') : temp[i].type === 1 ? this.$t('Bundles.week') : this.$t('Bundles.month')}`-->
<!--          })-->
<!--        } else if (this.sliderHolder === 'mtnApps') {-->
<!--          this.myData.push({-->
<!--            id: temp[i].id,-->
<!--            title: temp[i].title,-->
<!--            description: temp[i].description,-->
<!--            icon: gc.baseUrl + '/customerCare' + temp[i].icon,-->
<!--            link: temp[i].link,-->
<!--            background: gc.baseUrl + '/customerCare' + temp[i].background-->
<!--          })-->
<!--        } else if (this.sliderHolder === 'specialServices') {-->
<!--          this.myData.push({-->
<!--            id: temp[i].id,-->
<!--            title: temp[i].title,-->
<!--            description: temp[i].description,-->
<!--            link: temp[i].link-->
<!--          })-->
<!--        } else if (this.sliderHolder === 'bundle' || this.sliderHolder === 'segment') {-->
<!--          this.myData.push({-->
<!--            id: temp[i].id,-->
<!--            title: temp[i].title,-->
<!--            description: [-->
<!--              {-->
<!--                value: `${temp[i].dataSize} ${temp[i].dataUnit}`,-->
<!--                desc: temp[i].dataNote-->
<!--              },-->
<!--              {-->
<!--                value: `${temp[i].minuteCount}${this.$t('Bundles.min')}`,-->
<!--                desc: temp[i].minuteNote-->
<!--              },-->
<!--              {-->
<!--                value: `${temp[i].smsCount}${this.$t('Bundles.sms')}`,-->
<!--                desc: `${temp[i].price}${this.$t('Bundles.sp')}`-->
<!--              }-->
<!--            ],-->
<!--            price: `${temp[i].price}${this.$t('Bundles.sp')}`-->
<!--          })-->
<!--        } else if (this.sliderHolder === 'offer') {-->
<!--          this.myData.push({-->
<!--            id: temp[i].id,-->
<!--            title: temp[i].title,-->
<!--            description: temp[i].description,-->
<!--            price: `${temp[i].price} ${this.$t('Bundles.sp')}`,-->
<!--            link: temp[i].link-->
<!--          })-->
<!--        } else if (this.sliderHolder === 'investorRelations') {-->
<!--          this.myData.push({-->
<!--            id: temp[i].id,-->
<!--            desc: temp[i].text,-->
<!--            time: temp[i].date,-->
<!--            img: gc.baseUrl + '/customerCare' + temp[i].image,-->
<!--            file: gc.baseUrl + '/customerCare' + temp[i].investorFiles[0].file,-->
<!--            fileId: temp[i].id-->
<!--          })-->
<!--        } else if (this.sliderHolder === 'pressReleases') {-->
<!--          this.myData.push({-->
<!--            id: temp[i].id,-->
<!--            type: 'news',-->
<!--            img: gc.baseUrl + '/customerCare' + temp[i].newsMedia[0].media,-->
<!--            imgDesc: temp[i].title,-->
<!--            desc: temp[i].html,-->
<!--            time: temp[i].date-->
<!--          })-->
<!--        } else if (this.sliderHolder === 'socialResponsibility') {-->
<!--          this.myData.push({-->
<!--            id: temp[i].id,-->
<!--            img: gc.baseUrl + '/customerCare' + temp[i].socialResponsibilityMedia[0].media,-->
<!--            imgDesc: temp[i].title,-->
<!--            desc: temp[i].text,-->
<!--            time: temp[i].socialDate-->
<!--          })-->
<!--        }-->
<!--      }-->
<!--    },-->
<!--    emptyInitial (start, end) {-->
<!--      for (let i = start; i < end; i++) {-->
<!--        if (this.sliderHolder === 'popularBundles') {-->
<!--          this.myData.push({-->
<!--            id: -1,-->
<!--            title: '',-->
<!--            description: [{ value: '', desc: '' }, { value: '', desc: '' }, { value: '', desc: '' }],-->
<!--            icon: '',-->
<!--            price: '',-->
<!--            unit: ''-->
<!--          })-->
<!--        } else if (this.sliderHolder === 'mtnApps') {-->
<!--          this.myData.push({-->
<!--            id: -1,-->
<!--            title: '',-->
<!--            description: '',-->
<!--            icon: '',-->
<!--            link: '',-->
<!--            background: ''-->
<!--          })-->
<!--        } else if (this.sliderHolder === 'specialServices') {-->
<!--          this.myData.push({-->
<!--            id: -1,-->
<!--            title: '',-->
<!--            description: '',-->
<!--            link: ''-->
<!--          })-->
<!--        } else if (this.sliderHolder === 'bundle' || this.sliderHolder === 'segment') {-->
<!--          this.myData.push({-->
<!--            title: '',-->
<!--            description: [-->
<!--              {-->
<!--                value: '',-->
<!--                desc: ''-->
<!--              },-->
<!--              {-->
<!--                value: '',-->
<!--                desc: ''-->
<!--              },-->
<!--              {-->
<!--                value: '',-->
<!--                desc: ''-->
<!--              }-->
<!--            ],-->
<!--            price: ''-->
<!--          })-->
<!--        } else if (this.sliderHolder === 'offer') {-->
<!--          this.myData.push({-->
<!--            id: -1,-->
<!--            title: '',-->
<!--            description: '',-->
<!--            price: '',-->
<!--            link: ''-->
<!--          })-->
<!--        } else if (this.sliderHolder === 'investorRelations') {-->
<!--          this.myData.push({-->
<!--            desc: '',-->
<!--            time: '',-->
<!--            img: '',-->
<!--            file: '',-->
<!--            fileId: ''-->
<!--          })-->
<!--        } else if (this.sliderHolder === 'pressReleases') {-->
<!--          this.myData.push({-->
<!--            id: -1,-->
<!--            type: 'news',-->
<!--            img: '',-->
<!--            imgDesc: '',-->
<!--            desc: '',-->
<!--            time: ''-->
<!--          })-->
<!--        } else if (this.sliderHolder === 'socialResponsibility') {-->
<!--          this.myData.push({-->
<!--            id: -1,-->
<!--            img: '',-->
<!--            imgDesc: '',-->
<!--            desc: '',-->
<!--            time: ''-->
<!--          })-->
<!--        }-->
<!--      }-->
<!--    }-->
<!--  }-->
<!--}-->
<!--</script>-->
<!--<style lang="scss">-->
<!--#slider_layout {-->
<!--  //margin-top: -1rem;-->
<!--  overflow: hidden;-->
<!--  padding-bottom: 1.5rem;-->
<!--}-->
<!--.empty-img-container{-->
<!--  width: 350px;-->
<!--  img {-->
<!--    height: 100%;-->
<!--    width: 100%;-->
<!--  }-->
<!--}-->
<!--.right-current{-->
<!--  right: 4vw !important;-->
<!--}-->
<!--.left-current{-->
<!--  left: 4vw !important;-->
<!--}-->
<!--.no-data{-->
<!--  min-height: 600px;-->
<!--  font-size: 25px;-->
<!--  display: flex;-->
<!--  align-items: center;-->
<!--  justify-content: center;-->
<!--}-->
<!--div.slick-list,-->
<!--div.slick-track,-->
<!--.slick-slide.slick-cloned{-->
<!--  transition-delay: 10ms;-->
<!--}-->
<!--#contactUs .swiper-wrapper {-->
<!--  min-height: 400px !important;-->
<!--  padding: 30px 0px;-->
<!--}-->
<!--#contactUs .current-all{-->
<!--  bottom: -16px;-->
<!--}-->
<!--#contactUs .slider-content{-->
<!--  height: 100%;-->
<!--}-->
<!--.slick-slider.slick-initialized,-->
<!--.slick-list{-->
<!--  height: 100%;-->
<!--}-->
<!--#investor-card{-->
<!--  height: 590px;-->
<!--  padding-top: 22px;-->
<!--}-->
<!--#cards-slider{-->
<!--  height: 540px !important;-->
<!--}-->
<!--#normal-cards{-->
<!--  height: 590px !important;-->
<!--}-->
<!--#press-social-card{-->
<!--  height: 570px !important;-->
<!--}-->
<!--#bundle,-->
<!--#offers{-->
<!--  height: 570px;-->
<!--}-->
<!--@media (min-width: 500px) and (max-width: 1000px){-->
<!--  #normal-cards,-->
<!--  #bundle{-->
<!--    height: 550px !important;-->
<!--  }-->
<!--}-->
<!--@media (max-width: 550px) and (min-width: 400px) {-->
<!--  #investor-card{-->
<!--    padding-top: 28px;-->
<!--    height: 480px !important;-->
<!--  }-->
<!--  #press-social-card{-->
<!--    height: 470px !important;-->
<!--  }-->
<!--}-->
<!--@media (max-width: 500px) {-->
<!--  #normal-cards,-->
<!--  #bundle{-->
<!--    height: 530px !important;-->
<!--  }-->
<!--}-->
<!--@media (max-width: 400px) {-->
<!--  #investor-card{-->
<!--    padding-top: 0px;-->
<!--    height: 460px !important;-->
<!--  }-->
<!--  #press-social-card{-->
<!--    height: 455px !important;-->
<!--  }-->
<!--}-->
<!--</style>-->

<template>
  <div id="slider_layout">
    <div :id="id" class="slider-content" >
      <Loader v-if="load" />
      <Error v-if="failed" />
      <div :class="[myData.length === 0 ? 'd-flex align-items-center justify-center h-100' : 'h-100']">
        <div v-if="myData.length === 0 && !load && !failed" class="empty-img-container">
          <img :src="emptyImg"/>
        </div>
        <VueSlickCarousel
          @afterChange="changePage"
          v-bind="userRes2.includes(this.data.main.sectionId) ? wideCardSetting : userRes3.includes(this.data.main.sectionId) ? wideCardSetting : (type === 'offer' || pressType === 'social' || pressType === 'news') ? randomSettings : type === 'contactus' ? contactUsResponsive : settings"
          :rtl="this.$lang === 'ar' ? true : false"
          ref="slider1"
          :key="key"
          v-if="!load && !failed"
        >
          <div class="" v-for="(card,i) in myData" :key="i"
          >
            <div v-if="!useWideCard.includes(type) && type !== 'offer' && type !== 'contactus' && type !== 'press_releases_slider'">
              <outer-card :sliderHolder="sliderHolder" :data="card" :cardType="type" />
            </div>
            <div v-if="useWideCard.includes(type)">
              <wide-card :sliderHolder="sliderHolder" :data="card" :cardType="type" />
            </div>
            <div v-if="type === 'offer'" class="d-flex">
              <div class="w-100">
                <offer-card :data="card"/>
              </div>
            </div>
            <div v-if="type === 'contactus'" class="d-flex">
              <div class="w-100 d-flex justify-content-center align-items-center">
                <contactus-card :data="card"/>
              </div>
            </div>
            <div v-if="type === 'press_releases_slider'" class="">
              <press-releasess-card :data="card" :cardType="pressType"/>
            </div>
          </div>
        </VueSlickCarousel>
      </div>
      <div  v-if="totalElements > pageSize" :class="[this.$lang === 'ar' ? 'right-dir right-current' : 'left-current','current-all']">
        <span>
         <span v-if="currentSlide.toString().length === 1">0</span>{{ currentSlide }}
          <span class="all"> / <span v-if="totalElements.toString().length === 1">0</span>{{ totalElements }} </span>
        </span>
      </div>
    </div>
  </div>
</template>
<!--v-if="show && info.length > showPerPage"-->
<script>
import OuterCard from '../cards/OuterCard'
import empty from '../../assets/images/empty-data.png'
import VueSlickCarousel from 'vue-slick-carousel-rtl/dist/vue-slick-carousel-rtl.umd.js'
import 'vue-slick-carousel-rtl/dist/vue-slick-carousel-rtl.css'
import 'vue-slick-carousel-rtl/dist/vue-slick-carousel-theme.css'
import WideCard from '../cards/WideCard'
import $ from 'jquery'
import OfferCard from '../cards/OfferCard'
import ContactusCard from '../cards/ContactusCard'
import PressReleasessCard from '../cards/PressReleasessCard'
import Loader from '../LoaderBtn/Loader'
import Error from '../errorHandle/Error'
import gc from '../../utils/gc'
export default {
  name: 'SliderLayout',
  props: {
    data: {
      type: Object
    },
    id: String,
    pressType: String,
    method: String,
    obj: Object,
    sliderHolder: String,
    extraUrl: String,
    lineType: Number
  },
  components: { Error, PressReleasessCard, ContactusCard, OfferCard, VueSlickCarousel, OuterCard, WideCard, Loader },
  data () {
    return {
      emptyImg: empty,
      key: 0,
      info: [],
      type: 1,
      current: 1,
      active1: 0,
      active2: '',
      visited: [0],
      currentSlide: 1,
      perPage: 1,
      oldSlide: -100,
      userRes2: ['social_responsibility', 'press_releases'],
      userRes3: ['investor_relations'],
      useWideCard: ['social-responsibility', 'press-releases', 'investor-relations'],
      settings: {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 300,
        slidesToShow: 4,
        initialSlide: 2,
        centerMode: true,
        centerPadding: '125',
        slidesToScroll: 1,
        touchThreshold: 5,
        responsive: [
          {
            breakpoint: 1800,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
              initialSlide: 2,
              centerPadding: '60'
            }
          },
          {
            breakpoint: 1590,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              initialSlide: 1,
              centerPadding: '145'
            }
          },
          {
            breakpoint: 1400,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              infinite: true,
              dots: false,
              centerPadding: '100',
              initialSlide: 1
            }
          },
          {
            breakpoint: 1300,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              infinite: true,
              dots: false,
              centerPadding: '30',
              initialSlide: 1
            }
          },
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              infinite: true,
              dots: false,
              centerPadding: '150',
              initialSlide: 1
            }
          },
          {
            breakpoint: 1070,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              initialSlide: 1,
              centerPadding: '90'
            }
          },
          {
            breakpoint: 890,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              centerPadding: '0',
              initialSlide: 1
            }
          },
          {
            breakpoint: 720,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerPadding: '150',
              initialSlide: 0
            }
          },
          {
            breakpoint: 680,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerPadding: '140',
              initialSlide: 0
            }
          },
          {
            breakpoint: 660,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerPadding: '120',
              initialSlide: 0
            }
          },
          {
            breakpoint: 570,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerPadding: '100',
              initialSlide: 0
            }
          },
          {
            breakpoint: 540,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerPadding: '80',
              initialSlide: 0
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerPadding: '0',
              initialSlide: 0
            }
          },
          {
            breakpoint: 320,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerPadding: '0',
              initialSlide: 0
            }
          }
        ]
      },
      randomSettings: {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 300,
        slidesToShow: 4,
        initialSlide: 2,
        centerMode: true,
        centerPadding: '125',
        slidesToScroll: 1,
        touchThreshold: 5,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              dots: false,
              centerPadding: '150',
              initialSlide: 0
            }
          },
          {
            breakpoint: 1070,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              initialSlide: 0,
              centerPadding: '120'
            }
          },
          {
            breakpoint: 990,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerPadding: '0',
              initialSlide: 0
            }
          },
          {
            breakpoint: 870,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerPadding: '175',
              initialSlide: 0
            }
          },
          {
            breakpoint: 780,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              dots: false,
              centerPadding: '150',
              initialSlide: 0
            }
          },
          {
            breakpoint: 730,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              dots: false,
              centerPadding: '125',
              initialSlide: 0
            }
          },
          {
            breakpoint: 670,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerPadding: '100',
              initialSlide: 0
            }
          },
          {
            breakpoint: 630,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerPadding: '75',
              initialSlide: 0
            }
          },
          {
            breakpoint: 580,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerPadding: '55',
              initialSlide: 0
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerPadding: '0',
              initialSlide: 0
            }
          }
        ]
      },
      wideCardSetting: {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 300,
        slidesToShow: 3,
        initialSlide: 1,
        centerMode: true,
        centerPadding: '80',
        slidesToScroll: 3,
        touchThreshold: 5,
        responsive: [
          {
            breakpoint: 2000,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              infinite: true,
              dots: false,
              centerPadding: '160',
              initialSlide: 1
            }
          },
          {
            breakpoint: 1650,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              infinite: true,
              dots: false,
              centerPadding: '110',
              initialSlide: 1
            }
          },
          {
            breakpoint: 1500,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              infinite: true,
              dots: false,
              centerPadding: '50',
              initialSlide: 1
            }
          },
          {
            breakpoint: 1450,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              infinite: true,
              dots: false,
              centerPadding: '35',
              initialSlide: 1
            }
          },
          {
            breakpoint: 1400,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              infinite: true,
              dots: false,
              centerPadding: '25',
              initialSlide: 1
            }
          },
          {
            breakpoint: 1350,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              infinite: true,
              dots: false,
              centerPadding: '175',
              initialSlide: 1
            }
          },
          {
            breakpoint: 1300,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              infinite: true,
              dots: false,
              centerPadding: '150',
              initialSlide: 1
            }
          },
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              initialSlide: 1,
              centerPadding: '130'
            }
          },
          {
            breakpoint: 1120,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              initialSlide: 1,
              centerPadding: '100'
            }
          },
          {
            breakpoint: 1050,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              infinite: true,
              dots: false,
              centerPadding: '80',
              initialSlide: 1
            }
          },
          {
            breakpoint: 1000,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              infinite: true,
              dots: false,
              centerPadding: '30',
              initialSlide: 1
            }
          },
          {
            breakpoint: 930,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              infinite: true,
              dots: false,
              centerPadding: '0',
              initialSlide: 1
            }
          },
          {
            breakpoint: 880,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerPadding: '175',
              initialSlide: 0
            }
          },
          {
            breakpoint: 780,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              dots: false,
              centerPadding: '150',
              initialSlide: 0
            }
          },
          {
            breakpoint: 730,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              dots: false,
              centerPadding: '125',
              initialSlide: 0
            }
          },
          {
            breakpoint: 670,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerPadding: '100',
              initialSlide: 0
            }
          },
          {
            breakpoint: 630,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerPadding: '75',
              initialSlide: 0
            }
          },
          {
            breakpoint: 580,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerPadding: '55',
              initialSlide: 0
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerPadding: '0',
              initialSlide: 0
            }
          }
        ]
      },
      contactUsResponsive: {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 300,
        slidesToShow: 5,
        initialSlide: 1,
        centerMode: true,
        centerPadding: '80',
        slidesToScroll: 3,
        touchThreshold: 5,
        responsive: [
          {
            breakpoint: 1600,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
              infinite: true,
              dots: false,
              centerPadding: '110',
              initialSlide: 2
            }
          },
          {
            breakpoint: 1500,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
              infinite: true,
              dots: false,
              centerPadding: '110',
              initialSlide: 2
            }
          },
          {
            breakpoint: 1400,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
              infinite: true,
              dots: false,
              centerPadding: '70',
              initialSlide: 2
            }
          },
          {
            breakpoint: 1300,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
              infinite: true,
              dots: false,
              centerPadding: '60',
              initialSlide: 2
            }
          },
          {
            breakpoint: 1250,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
              infinite: true,
              dots: false,
              centerPadding: '40',
              initialSlide: 2
            }
          },
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
              initialSlide: 2,
              centerPadding: '40 '
            }
          },
          {
            breakpoint: 1170,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
              initialSlide: 2,
              centerPadding: '20 '
            }
          },
          {
            breakpoint: 1115,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              initialSlide: 1,
              centerPadding: '110'
            }
          },
          {
            breakpoint: 1020,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              initialSlide: 1,
              centerPadding: '60'
            }
          },
          {
            breakpoint: 950,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              initialSlide: 1,
              centerPadding: '40'
            }
          },
          {
            breakpoint: 915,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              initialSlide: 1,
              centerPadding: '20'
            }
          },
          {
            breakpoint: 880,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              initialSlide: 1,
              centerPadding: '10'
            }
          },
          {
            breakpoint: 850,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              centerPadding: '20',
              initialSlide: 1
            }
          },
          {
            breakpoint: 840,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              centerPadding: '10',
              initialSlide: 1
            }
          },
          {
            breakpoint: 820,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              centerPadding: '100',
              initialSlide: 1
            }
          },
          {
            breakpoint: 755,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              centerPadding: '75',
              initialSlide: 1
            }
          },
          {
            breakpoint: 700,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              centerPadding: '40',
              initialSlide: 1
            }
          },
          {
            breakpoint: 655,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              centerPadding: '45',
              initialSlide: 1
            }
          },
          {
            breakpoint: 630,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              centerPadding: '20',
              initialSlide: 1
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              centerPadding: '5',
              initialSlide: 1
            }
          },

          {
            breakpoint: 550,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerPadding: '0',
              initialSlide: 0
            }
          }
        ]
      },
      direction: false,
      flipNum: 0,
      centerModeProp: false,
      showPerPage: 0,
      display: this.show,
      /* -------- new logic ----------- */
      myData: [],
      load: false,
      failed: false,
      size: 5,
      shouldBeDragged: 0,
      totalElements: 0,
      pageSize: 0,
      latestPagesNum: 0,
      fetchedPages: []
    }
  },
  watch: {
  },
  created () {
    this.info = this.data.slider
    this.type = this.data.main.cardType
    if (this.data.sliderType === 'cardsMiniSlider') { // this data will be received in case of mobile screen which will convert the random cards section to a slider
      this.getMiniSliderData() // if the previous condition return true this function will be called
    } else { // or in normal case this is the function that will called
      this.getData(0)
    }
  },
  mounted () {
    this.$lang === 'ar' ? this.direction = true : this.direction = false
    setTimeout(() => {
      this.styling()
    })
    this.$watch(() => {
      return this.$store.state.window
    }, (val) => {
      this.styling()
    })
  },
  methods: {
    async getMiniSliderData () {
      this.load = true
      try {
        const response = await this.obj[this.method]()
        if (response.status === 200) {
          for (let i = 0; i < response.data.length; i++) {
            let temp
            if (this.sliderHolder === 'pressReleases') { // if this slider in press releases section this is the passed object
              temp = { id: response.data[i].id, title: response.data[i].title, description: response.data[i].html, icon: gc.baseUrl + '/customerCare' + response.data[i].newsMedia[0].media, styles: i === 0 ? 'col-lg-8 col-12 main' : i === 1 ? 'col-lg-12 col-6 second' : 'col-lg-12 col-6 third' }
            } else if (this.sliderHolder === 'randomOffers') { // if the slider in random offers section in home page this object will be passed
              temp = { type: 'random-offers', title: response.data[i].title, description: response.data[i].description, link: response.data[i].link, icon: gc.baseUrl + '/customerCare' + response.data[i].largeImage, smallIcon: gc.baseUrl + '/customerCare' + response.data[i].smallImage, styles: i === 0 ? 'col-lg-8 col-12 main' : i === 1 ? 'col-lg-12 col-6 second' : i === 2 ? 'col-lg-12 col-6 third' : '' }
            } else if (this.sliderHolder === 'socialResponsibility') { // if the slider in social responibility
              temp = {
                id: response.data[i].id,
                title: response.data[i].title,
                description: response.data[i].text,
                icon: gc.baseUrl + '/customerCare' + response.data[i].socialResponsibilityMedia[0].media,
                styles: i === 0 ? 'col-lg-8 col-12 main' : i === 1 ? 'col-lg-12 col-6 second' : 'col-lg-12 col-6 third'
              }
            } else if (this.sliderHolder === 'contactUs') {
              temp = response.data[i]
            }
            this.myData.push(temp)
          }
          this.totalElements = response.data.length
        } else {
          this.failed = true
        }
      } catch (e) {
        this.failed = true
      }
      this.load = false
    },
    styling () {
      this.$lang === 'ar' ? $('.current-all').css('right', '4vw') : $('.current-all').css('left', '4vw')
      $('#investor_relations .current-all').css('bottom', '-12px')
      $('#investor_relations .swipe').css('bottom', '-5px')
      $('#social_responsibility .current-all').css('bottom', '2px')
      $('#social_responsibility .current-all').css('padding-bottom', '2px')
      this.$lang === 'ar' ? $('img.arrows').css('transform', 'rotateY(180deg)') : $('img.arrows').css('transform', 'rotateY(0deg)')
      this.$lang === 'ar' ? $('#slider_layout img.outer_image').css('transform', 'rotateY(180deg)') : $('#slider_layout img.outer_image').css('transform', 'rotateY(0deg)')
      this.$lang === 'ar' ? $('#slider_layout #inner_card').css('right', '48.5px') : $('#slider_layout #inner_card').css('right', '64.5px')
      if (this.type === 'contactus') {
        $(`#${this.data.main.sectionId} .slider-container`).css('height', '100%')
        $(`#${this.data.main.sectionId} #slider_layout`).css('margin-top', '2rem')
        $(`#${this.data.main.sectionId} #slider_layout`).css('height', '420px')
      }
    },
    changePage (num) {
      if (this.totalElements <= this.$refs.slider1.settings.slidesToShow) {
        return // dont do anything if the totalElements less than how many slider must be shown in the screen
      }
      if (this.$refs.slider1.$children[0].currentDirection === 0 && num !== this.oldSlide) { // check the direction of the dragging is forward
        if (this.currentSlide + 1 <= this.totalElements) { // if the current slide added by one is less than the totalElements length
          this.currentSlide += 1 // if the condition true then increase it by one
        } else {
          this.currentSlide = 1 // else return to one
        }
        this.changeForward(this.currentSlide)
      }
      if (this.$refs.slider1.$children[0].currentDirection === 1 && num !== this.oldSlide) { // check the direction of the dragging is backward
        if (this.currentSlide - 1 <= 0) { // if we the current slide decreased by one less than or equal to zero
          this.currentSlide = this.totalElements // make the current slide is the last element of the array
        } else {
          this.currentSlide -= 1 // else decrease it by one
        }
        this.changeBackward(this.currentSlide)
      }
      this.oldSlide = num
    },
    async getData (page) {
      this.load = true // start the loader
      const size = this.size // page size
      const obj = this.obj // the instance object of the repositories folder classes
      const method = this.method // the method name
      const id = this.data.id // the id of the url (passed with the data object from the main section)
      const type = this.data.durationType // if the type daily, weakly or monthly (passed with the data object from the main section)
      const line = this.data.lineType // if the line type prepaid or post paid (passed with the data object from the main section)
      try {
        let response
        if (this.data.sliderType === 'press&social') { // passed from the main section to specify the passed parameters
          response = await obj[method](this.extraUrl, page, size)
        } else if (this.data.sliderType === 'bundle' || this.data.sliderType === 'segment') {
          response = await obj[method](id, page, size, type, this.lineType)
        } else if (this.data.sliderType === 'offer') {
          response = await obj[method](id, page, size, line)
        } else {
          response = await obj[method](page, size)
        }
        if (response.status === 200) {
          this.fetchedPages.push(page) // if the page fetched successfully we push its number to this array to prevent reorder it
          const temp = this.data.sliderType === 'bundle' || this.data.sliderType === 'segment' ? response.content : this.data.sliderType === 'offer' ? response.data.data.data : response.data.data
          await this.firstPushRendering(temp)
          this.totalElements = this.data.sliderType === 'bundle' || this.data.sliderType === 'segment' ? response.count : this.data.sliderType === 'offer' ? response.data.data.totalElements : response.data.totalElements
          this.shouldBeDragged = Math.ceil(this.totalElements / size) // how many times we should request pages to get the total data
          if (this.shouldBeDragged > 1) {
            await this.emptyInitial(this.size, this.totalElements)
          }
        } else {
          this.failed = true
        }
      } catch (e) {
        console.log(e)
        this.failed = true
      }
      if (this.shouldBeDragged === 2) {
        await this.getEdgeData(1)
      } else if (this.shouldBeDragged > 2) {
        await this.getEdgeData(1)
        await this.getEdgeData(this.shouldBeDragged - 1)
      }
      this.load = false
      setTimeout(() => {
        this.pageSize = Math.ceil(this.$refs.slider1.settings.slidesToShow)
        this.$emit('total-elements', { total: this.totalElements, pageSize: Math.ceil(this.$refs.slider1.settings.slidesToShow) })
      })
    },
    async getEdgeData (page) {
      const size = this.size
      const obj = this.obj
      const method = this.method
      const id = this.data.id
      const type = this.data.durationType
      const line = this.data.lineType
      try {
        let response
        if (this.data.sliderType === 'press&social') {
          response = await obj[method](this.extraUrl, page, size)
        } else if (this.data.sliderType === 'bundle' || this.data.sliderType === 'segment') {
          response = await obj[method](id, page, size, type, this.lineType)
        } else if (this.data.sliderType === 'offer') {
          response = await obj[method](id, page, size, line)
        } else {
          response = await obj[method](page, size)
        }
        if (response.status === 200) {
          this.fetchedPages.push(page)
          const temp = this.data.sliderType === 'bundle' || this.data.sliderType === 'segment' ? response.content : this.data.sliderType === 'offer' ? response.data.data.data : response.data.data
          if (page === 1) {
            this.rendering(temp, page, (page + 1) * this.size)
          } else {
            this.rendering(temp, page, this.totalElements)
          }
        } else {
          this.failed = true
        }
      } catch (e) {
        console.log(e)
        // the next row returns an error
        // this.failed = true
      }
    },
    async changeForward (val) {
      const page = Math.floor((val - 1) / this.size) + 2// the val is the number of the current slide that the page is the number of the page of this slide
      const size = this.size
      const obj = this.obj
      const method = this.method
      const id = this.data.id
      const type = this.data.durationType
      const line = this.data.lineType
      if (!this.fetchedPages.includes(page) && page < this.shouldBeDragged - 1 && val % this.size === 0) { // check if this page fetched before and the page number is less than how many elements should be dragged and the last condition is to prevent the user from asking the page in each swipe and ask for the page after in the edge of the page
        try {
          let response
          if (this.data.sliderType === 'press&social') {
            response = await obj[method](this.extraUrl, page, size)
          } else if (this.data.sliderType === 'bundle' || this.data.sliderType === 'segment') {
            response = await obj[method](id, page, size, type, this.lineType)
          } else if (this.data.sliderType === 'offer') {
            response = await obj[method](id, page, size, line)
          } else {
            response = await obj[method](page, size)
          }
          if (response.status === 200) {
            const temp = this.data.sliderType === 'bundle' || this.data.sliderType === 'segment' ? response.content : this.data.sliderType === 'offer' ? response.data.data.data : response.data.data
            this.rendering(temp, page, (page + 1) * this.size)
            this.fetchedPages.push(page)
            setTimeout(() => {
              this.$refs.slider1.$forceUpdate()
              this.$store.state.sliderUpdated++
            })
          }
        } catch (e) {
          return e
        }
      } else if (!this.visited.includes(page) && page === this.shouldBeDragged - 1 && val % this.size === 0) {
        try {
          let response
          if (this.data.sliderType === 'press&social') {
            response = await obj[method](this.extraUrl, page, size)
          } else if (this.data.sliderType === 'bundle' || this.data.sliderType === 'segment') {
            response = await obj[method](id, page, size, type, this.lineType)
          } else if (this.data.sliderType === 'offer') {
            response = await obj[method](id, page, size, line)
          } else {
            response = await obj[method](page, size)
          }
          if (response.status === 200) {
            const temp = this.data.sliderType === 'bundle' || this.data.sliderType === 'segment' ? response.content : this.data.sliderType === 'offer' ? response.data.data.data : response.data.data
            this.rendering(temp, page, this.totalElements)
            this.fetchedPages.push(page)
            setTimeout(() => {
              this.$refs.slider1.$forceUpdate()
              this.$store.state.sliderUpdated++
            })
          }
        } catch (e) {
          return e
        }
      }
    },
    async changeBackward (val) {
      const page = Math.floor((val - 1) / this.size) - 1
      const size = this.size
      const obj = this.obj
      const method = this.method
      const id = this.data.id
      const type = this.data.durationType
      const line = this.data.lineType
      if (!this.fetchedPages.includes(page) && page < this.shouldBeDragged - 1 && page > 0 && (val % this.size === 0)) {
        try {
          let response
          if (this.data.sliderType === 'press&social') {
            response = await obj[method](this.extraUrl, page, size)
          } else if (this.data.sliderType === 'bundle' || this.data.sliderType === 'segment') {
            response = await obj[method](id, page, size, type, this.lineType)
          } else if (this.data.sliderType === 'offer') {
            response = await obj[method](id, page, size, line)
          } else {
            response = await obj[method](page, size)
          }
          if (response.status === 200) {
            const temp = this.data.sliderType === 'bundle' || this.data.sliderType === 'segment' ? response.content : this.data.sliderType === 'offer' ? response.data.data.data : response.data.data
            this.fetchedPages.push(page)
            this.rendering(temp, page, (page + 1) * this.size)
          }
        } catch (e) {
          return e
        }
      } else if (!this.fetchedPages.includes(page) && page === this.shouldBeDragged - 2 && page > 0) {
        try {
          let response
          if (this.data.sliderType === 'press&social') {
            response = await obj[method](this.extraUrl, page, size)
          } else if (this.data.sliderType === 'bundle' || this.data.sliderType === 'segment') {
            response = await obj[method](id, page, size, type, this.lineType)
          } else if (this.data.sliderType === 'offer') {
            response = await obj[method](id, page, size, line)
          } else {
            response = await obj[method](page, size)
          }
          if (response.status === 200) {
            const temp = this.data.sliderType === 'bundle' || this.data.sliderType === 'segment' ? response.content : this.data.sliderType === 'offer' ? response.data.data.data : response.data.data
            this.fetchedPages.push(page)
            this.rendering(temp, page, this.totalElements)
          }
        } catch (e) {
          return e
        }
      }
    },
    rendering (temp, page, elements) {
      for (let i = page * this.size; i < elements; i++) {
        if (this.sliderHolder === 'popularBundles') {
          this.myData[i].id = temp[i - (page * this.size)].id
          this.myData[i].title = temp[i - (page * this.size)].title
          this.myData[i].description[0].value = `${temp[i - (page * this.size)].dataSize} ${temp[i - (page * this.size)].dataUnit}`
          this.myData[i].description[0].desc = temp[i - (page * this.size)].dataNote
          this.myData[i].description[1].value = `${temp[i - (page * this.size)].minuteCount}${this.$t('Bundles.min')}`
          this.myData[i].description[1].desc = temp[i - (page * this.size)].minuteNote
          this.myData[i].description[2].value = `${temp[i - (page * this.size)].smsCount}${this.$t('Bundles.sms')}`
          this.myData[i].description[2].desc = temp[i - (page * this.size)].smsNote
          // this.myData[i].price = `${temp[i - (page * this.size)].price} ${this.$t('Bundles.sp')}`
          this.myData[i].price = `${temp[i - (page * this.size)].price === 0 ? this.$t('free') : temp[i - (page * this.size)].price + this.$t('Bundles.sp')}`
          // this.myData[i].unit = `/ ${temp[i - (page * this.size)].type === 0 ? this.$t('Bundles.day') : temp[i - (page * this.size)].type === 1 ? this.$t('Bundles.week') : this.$t('Bundles.month')}`
          this.myData[i].unit = `${temp[i - (page * this.size)].validity === 1 ? '' : temp[i - (page * this.size)].validity} ${temp[i - (page * this.size)].type === 0 ? this.$t('Bundles.day') : temp[i - (page * this.size)].type === 1 ? this.$t('Bundles.week') : this.$t('Bundles.month')}`
        } else if (this.sliderHolder === 'mtnApps') {
          // console.log('temp', temp)
          // console.log('page', page)
          // console.log('elements', elements)
          // console.log('page * this.size', page * this.size)
          // console.log('page * this.size', temp[i - page * this.size])
          this.myData[i].id = temp[i - (page * this.size)].id
          this.myData[i].title = temp[i - (page * this.size)].title
          this.myData[i].description = temp[i - (page * this.size)].description
          this.myData[i].icon = gc.baseUrl + '/customerCare' + temp[i - (page * this.size)].icon
          this.myData[i].link = temp[i - (page * this.size)].link
          this.myData[i].background = gc.baseUrl + '/customerCare' + temp[i - (page * this.size)].background
        } else if (this.sliderHolder === 'specialServices') {
          this.myData[i].id = temp[i - (page * this.size)].id
          this.myData[i].title = temp[i - (page * this.size)].title
          this.myData[i].description = temp[i - (page * this.size)].description
          this.myData[i].link = temp[i - (page * this.size)].link
        } else if (this.sliderHolder === 'bundle' || this.sliderHolder === 'segment') {
          this.myData[i].id = temp[i - (page * this.size)].id
          this.myData[i].title = temp[i - (page * this.size)].title
          this.myData[i].description[0].value = `${temp[i - (page * this.size)].dataSize} ${temp[i - (page * this.size)].dataUnit}`
          this.myData[i].description[0].desc = temp[i - (page * this.size)].dataNote
          this.myData[i].description[1].value = `${temp[i - (page * this.size)].minuteCount}${this.$t('Bundles.min')}`
          this.myData[i].description[1].desc = temp[i - (page * this.size)].minuteNote
          this.myData[i].description[2].value = `${temp[i - (page * this.size)].smsCount}${this.$t('Bundles.sms')}`
          this.myData[i].description[2].desc = temp[i - (page * this.size)].smsNote
          // this.myData[i].price = `${temp[i - (page * this.size)].price}${this.$t('Bundles.sp')}`
          this.myData[i].price = `${temp[i - (page * this.size)].price === 0 ? this.$t('free') : temp[i - (page * this.size)].price + this.$t('Bundles.sp')}`
          this.myData[i].unit = `${temp[i - (page * this.size)].validity === 1 ? '' : temp[i - (page * this.size)].validity} ${temp[i - (page * this.size)].type === 0 ? this.$t('Bundles.day') : temp[i - (page * this.size)].type === 1 ? this.$t('Bundles.week') : this.$t('Bundles.month')}`
          // this.myData[i].unit = `/ ${temp[i - (page * this.size)].type === 0 ? this.$t('Bundles.day') : temp[i - (page * this.size)].type === 1 ? this.$t('Bundles.week') : this.$t('Bundles.month')}`
        } else if (this.sliderHolder === 'offer') {
          this.myData[i].id = temp[i - (page * this.size)].id
          this.myData[i].title = temp[i - (page * this.size)].title
          this.myData[i].description = temp[i - (page * this.size)].description
          // this.myData[i].price = temp[i - (page * this.size)].price
          // this.myData[i].price = `${temp[i - (page * this.size)].price} ${this.$t('Bundles.sp')}`
          this.myData[i].price = `${temp[i - (page * this.size)].price === 0 ? this.$t('free') : temp[i - (page * this.size)].price + this.$t('Bundles.sp')}`
          this.myData[i].link = temp[i - (page * this.size)].link
        } else if (this.sliderHolder === 'investorRelations') {
          this.myData[i].id = temp[i - (page * this.size)].id
          this.myData[i].desc = temp[i - (page * this.size)].text
          this.myData[i].date = temp[i - (page * this.size)].date
          this.myData[i].img = gc.baseUrl + '/customerCare' + temp[i - (page * this.size)].image
          this.myData[i].file = gc.baseUrl + '/customerCare' + temp[i - (page * this.size)].investorFiles[0].file
          this.myData[i].fileId = temp[i - (page * this.size)].investorFiles[0].id
        } else if (this.sliderHolder === 'pressReleases') {
          this.myData[i].id = temp[i - (page * this.size)].id
          this.myData[i].title = temp[i - (page * this.size)].title
          this.myData[i].description = temp[i - (page * this.size)].description
          this.myData[i].icon = gc.baseUrl + '/customerCare' + temp[i - (page * this.size)].icon
          this.myData[i].slider[i].link = temp[i - (page * this.size)].link
        } else if (this.sliderHolder === 'socialResponsibility') {
          this.myData[i].id = temp[i - (page * this.size)].id
          this.myData[i].img = gc.baseUrl + '/customerCare' + temp[i - (page * this.size)].socialResponsibilityMedia[0].media
          this.myData[i].imgDesc = temp[i - (page * this.size)].title
          this.myData[i].desc = temp[i - (page * this.size)].text
          this.myData[i].time = temp[i - (page * this.size)].socialDate
        }
      }
    },
    firstPushRendering (temp) {
      for (let i = 0; i < temp.length; i++) {
        if (this.sliderHolder === 'popularBundles') {
          this.myData.push({
            id: temp[i].id,
            title: temp[i].title,
            description: [{ value: `${temp[i].dataSize} ${temp[i].dataUnit}`, desc: temp[i].dataNote }, { value: `${temp[i].minuteCount}${this.$t('Bundles.min')}`, desc: temp[i].minuteNote }, { value: `${temp[i].smsCount}${this.$t('Bundles.sms')}`, desc: temp[i].smsNote }],
            icon: '',
            // price: `${temp[i].price} ${this.$t('Bundles.sp')} `,
            price: `${temp[i].price === 0 ? this.$t('free') : temp[i].price + this.$t('Bundles.sp')}`,
            unit: `/ ${temp[i].validity === 1 ? '' : temp[i].validity + ' '}${temp[i].type === 0 ? this.$t('Bundles.day') : temp[i].type === 1 ? this.$t('Bundles.week') : this.$t('Bundles.month')}`
          })
        } else if (this.sliderHolder === 'mtnApps') {
          this.myData.push({
            id: temp[i].id,
            title: temp[i].title,
            description: temp[i].description,
            icon: gc.baseUrl + '/customerCare' + temp[i].icon,
            link: temp[i].link,
            background: gc.baseUrl + '/customerCare' + temp[i].background
          })
        } else if (this.sliderHolder === 'specialServices') {
          this.myData.push({
            id: temp[i].id,
            title: temp[i].title,
            description: temp[i].description,
            link: temp[i].link
          })
        } else if (this.sliderHolder === 'bundle' || this.sliderHolder === 'segment') {
          this.myData.push({
            id: temp[i].id,
            title: temp[i].title,
            description: [
              {
                value: `${temp[i].dataSize} ${temp[i].dataUnit}`,
                desc: temp[i].dataNote
              },
              {
                value: `${temp[i].minuteCount}${this.$t('Bundles.min')}`,
                desc: temp[i].minuteNote
              },
              {
                value: `${temp[i].smsCount}${this.$t('Bundles.sms')}`,
                desc: temp[i].smsNote
              }
            ],
            price: `${temp[i].price === 0 ? this.$t('free') : temp[i].price + this.$t('Bundles.sp')}`,
            unit: `/ ${temp[i].validity === 1 ? '' : temp[i].validity + ' '}${temp[i].type === 0 ? this.$t('Bundles.day') : temp[i].type === 1 ? this.$t('Bundles.week') : this.$t('Bundles.month')}`
          })
        } else if (this.sliderHolder === 'offer') {
          this.myData.push({
            id: temp[i].id,
            title: temp[i].title,
            description: temp[i].description,
            // price: `${temp[i].price} ${this.$t('Bundles.sp')}`,
            price: `${temp[i].price === 0 ? this.$t('free') : temp[i].price + this.$t('Bundles.sp')}`,
            link: temp[i].link
          })
        } else if (this.sliderHolder === 'investorRelations') {
          this.myData.push({
            id: temp[i].id,
            desc: temp[i].text,
            time: temp[i].date,
            img: gc.baseUrl + '/customerCare' + temp[i].image,
            file: gc.baseUrl + '/customerCare' + temp[i].investorFiles[0].file,
            fileId: temp[i].investorFiles[0].id
          })
        } else if (this.sliderHolder === 'pressReleases') {
          this.myData.push({
            id: temp[i].id,
            type: 'news',
            img: gc.baseUrl + '/customerCare' + temp[i].newsMedia[0].media,
            imgDesc: temp[i].title,
            desc: temp[i].html,
            time: temp[i].date
          })
        } else if (this.sliderHolder === 'socialResponsibility') {
          this.myData.push({
            id: temp[i].id,
            type: 'social',
            img: gc.baseUrl + '/customerCare' + temp[i].socialResponsibilityMedia[0].media,
            imgDesc: temp[i].title,
            desc: temp[i].text,
            time: temp[i].socialDate
          })
        }
      }
    },
    emptyInitial (start, end) {
      for (let i = start; i < end; i++) {
        if (this.sliderHolder === 'popularBundles') {
          this.myData.push({
            id: -1,
            title: '',
            description: [{ value: '', desc: '' }, { value: '', desc: '' }, { value: '', desc: '' }],
            icon: '',
            price: '',
            unit: ''
          })
        } else if (this.sliderHolder === 'mtnApps') {
          this.myData.push({
            id: -1,
            title: '',
            description: '',
            icon: '',
            link: '',
            background: ''
          })
        } else if (this.sliderHolder === 'specialServices') {
          this.myData.push({
            id: -1,
            title: '',
            description: '',
            link: ''
          })
        } else if (this.sliderHolder === 'bundle' || this.sliderHolder === 'segment') {
          this.myData.push({
            title: '',
            description: [
              {
                value: '',
                desc: ''
              },
              {
                value: '',
                desc: ''
              },
              {
                value: '',
                desc: ''
              }
            ],
            price: ''
          })
        } else if (this.sliderHolder === 'offer') {
          this.myData.push({
            id: -1,
            title: '',
            description: '',
            price: '',
            link: ''
          })
        } else if (this.sliderHolder === 'investorRelations') {
          this.myData.push({
            desc: '',
            time: '',
            img: '',
            file: '',
            fileId: ''
          })
        } else if (this.sliderHolder === 'pressReleases') {
          this.myData.push({
            id: -1,
            type: 'news',
            img: '',
            imgDesc: '',
            desc: '',
            time: ''
          })
        } else if (this.sliderHolder === 'socialResponsibility') {
          this.myData.push({
            id: -1,
            type: 'social',
            img: '',
            imgDesc: '',
            desc: '',
            time: ''
          })
        }
      }
    }
  }
}
</script>
<style lang="scss">
#slider_layout {
  //margin-top: -1rem;
  overflow: hidden;
  padding-bottom: 1.5rem;
}
.empty-img-container{
  width: 350px;
  img {
    height: 100%;
    width: 100%;
  }
}
.right-current{
  right: 4vw !important;
}
.left-current{
  left: 4vw !important;
}
.no-data{
  min-height: 600px;
  font-size: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
}
div.slick-list,
div.slick-track,
.slick-slide.slick-cloned{
  transition-delay: 10ms;
}
#contactUs .swiper-wrapper {
  min-height: 400px !important;
  padding: 30px 0px;
}
#contactUs .current-all{
  bottom: -16px;
}
#contactUs .slider-content{
  height: 100%;
}
.slick-slider.slick-initialized,
.slick-list{
  height: 100%;
}
#investor-card{
  height: 590px;
  padding-top: 22px;
}
#cards-slider{
  height: 540px !important;
}
#normal-cards{
  height: 590px !important;
}
#press-social-card{
  height: 570px !important;
}
#bundle,
#offers{
  height: 570px;
}
@media (min-width: 500px) and (max-width: 1000px){
  #normal-cards,
  #bundle{
    height: 550px !important;
  }
}
@media (max-width: 550px) and (min-width: 400px) {
  #investor-card{
    padding-top: 28px;
    height: 480px !important;
  }
  #press-social-card{
    height: 470px !important;
  }
}
@media (max-width: 500px) {
  #normal-cards,
  #bundle{
    height: 530px !important;
  }
}
@media (max-width: 400px) {
  #investor-card{
    padding-top: 0px;
    height: 460px !important;
  }
  #press-social-card{
    height: 455px !important;
  }
}
</style>
